import { gql } from '@apollo/client';

export const GET_SORTER_BY_ID = gql`
  query GetSorterById($id: ID!) {
    getSorterById(id: $id) {
      id
      sorterType
    }
  }
`;

export interface Sorter {
  id: string;
  sorterType?: number;
}

export interface GetSorterByIdData {
  getSorterById: Sorter | null;
}

export interface GetSorterByIdVariables {
  id: string;
}
